import { createIcon } from '@mote/ui/components/icon'
import { defaultProps } from './defaultProps'

export const PlayIcon = createIcon({
  displayName: 'PlayIcon',
  path: (
    <path
      d='M8 6.82v10.36c0 .79.87 1.27 1.54.84l8.14-5.18a1 1 0 0 0 0-1.69L9.54 5.98A.998.998 0 0 0 8 6.82Z'
      fill='currentColor'
    />
  ),
  defaultProps: defaultProps
})
